import { companyRequest } from '@/utils/request'

import {
    QueryOrderUploadFailureDetailsParams,
    OrderUploadFailureDetailVo,
    QueryOrderUploadFailedInfoParams,
    UploadFailedInfoVo,
    QueryAutoReturnFailureDetailsParams,
    AutoReturnFailureDetailVo,
    QueryAutoReturnFailedInfoParams,
    QueryAsyncDownloadResultParams,
    QueryAfterSaleAddressUsageAnalysisListParams,
    PageDistributionAfterSaleReportVo,
    DownloadOrderUploadFailureDetailsParams,
    DownloadAutoReturnFailureDetailsParams,
} from '@servicesTypings/companyRequestV3'

import {
    QueryAfterSaleAddressUsageAnalysisStatisticsParams,
    AfterSaleAddressUsageAnalysisStatisticsVo,
} from '@servicesTypings/companyRequestV3'

/**
 * 查询上传失败订单明细
 */
export function queryOrderUploadFailureDetails(
    params: QueryOrderUploadFailureDetailsParams,
): API.Res<OrderUploadFailureDetailVo[]> {
    return companyRequest.get('/op/aftersale/queryOrderUploadFailureDetails', { params })
}

/**
 * 查询订单上传失败信息
 */
export function queryOrderUploadFailedInfo(params: QueryOrderUploadFailedInfoParams): API.Res<UploadFailedInfoVo[]> {
    return companyRequest.get('/op/aftersale/queryOrderUploadFailedInfo', { params })
}

/**
 * 查询自动退货失败售后单明细
 */
export function queryAutoReturnFailureDetails(
    params: QueryAutoReturnFailureDetailsParams,
): API.Res<AutoReturnFailureDetailVo[]> {
    return companyRequest.get('/op/aftersale/queryAutoReturnFailureDetails', { params })
}

/**
 * 查询自动退货失败信息
 */
export function queryAutoReturnFailedInfo(params: QueryAutoReturnFailedInfoParams): API.Res<UploadFailedInfoVo[]> {
    return companyRequest.get('/op/aftersale/queryAutoReturnFailedInfo', { params })
}

/**
 * 查询异步下载结果
 */
export function queryAsyncDownloadResult(params: QueryAsyncDownloadResultParams): API.Res<string> {
    return companyRequest.get('/op/aftersale/queryAsyncDownloadResult', { params })
}

/**
 * 查询售后地址使用分析列表
 */
export function queryAfterSaleAddressUsageAnalysisList(
    params: QueryAfterSaleAddressUsageAnalysisListParams,
): API.Res<PageDistributionAfterSaleReportVo> {
    return companyRequest.get('/op/aftersale/queryAfterSaleAddressUsageAnalysisList', { params })
}

/**
 * 下载上传失败订单明细
 */
export function downloadOrderUploadFailureDetails(params: DownloadOrderUploadFailureDetailsParams): API.Res<string> {
    return companyRequest.get('/op/aftersale/downloadOrderUploadFailureDetails', { params })
}

/**
 * 下载自动退货失败售后单明细
 */
export function downloadAutoReturnFailureDetails(params: DownloadAutoReturnFailureDetailsParams): API.Res<string> {
    return companyRequest.get('/op/aftersale/downloadAutoReturnFailureDetails', { params })
}

/**
 * 查询售后地址使用分析列表
 */
export function queryAfterSaleAddressUsageAnalysisStatistics(
    params: QueryAfterSaleAddressUsageAnalysisStatisticsParams,
): API.Res<AfterSaleAddressUsageAnalysisStatisticsVo> {
    return companyRequest.get('/op/aftersale/queryAfterSaleAddressUsageAnalysisStatistics', { params })
}
